module.exports = __webpack_public_path__ + "static/img/nbyaohang2.e584060.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/nbyaohang2.png
// module id = l+IG
// module chunks = 9